(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-maison"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const fenetre = document.getElementById('fenetre-maison');
    if (!fenetre || typeof fenetre.showModal !== 'function') return;

    const CLE = 'maison:fenetre-vue';
    const repos = Number(fenetre.dataset.repos || 14);
    const delai = Number(fenetre.dataset.delai || 6);
    const empreinte = fenetre.dataset.empreinte || '';

    // La mémoire est liée à l'OFFRE, pas seulement à la date. Changer le code ou
    // le titre change l'empreinte : une personne qui avait fermé l'offre
    // précédente revoit la nouvelle, au lieu de rester muette jusqu'à la fin du
    // repos. C'est exactement ce qui s'est produit au passage de 25 % à 10 %.
    //
    // localStorage peut lever (navigation privée, cookies bloqués) : dans ce cas
    // la fenêtre s'affiche simplement à chaque visite plutôt que de casser.
    const lu = () => {
      try {
        const brut = localStorage.getItem(CLE);
        if (!brut) return 0;
        // Ancien format : une simple date, sans empreinte. On l'ignore.
        if (!brut.startsWith('{')) return 0;
        const v = JSON.parse(brut);
        return v.e === empreinte ? Number(v.d) || 0 : 0;
      } catch { return 0; }
    };
    const noter = () => {
      try {
        localStorage.setItem(CLE, JSON.stringify({ e: empreinte, d: Date.now() }));
      } catch { /* sans effet */ }
    };

    const ouvrir = () => {
      if (fenetre.open) return;
      fenetre.showModal();
    };

    const fermer = () => {
      noter();
      if (fenetre.open) fenetre.close();
    };

    fenetre.querySelectorAll('[data-fermer]').forEach((b) => b.addEventListener('click', fermer));
    // Échap est géré par le navigateur : on mémorise quand même le refus.
    fenetre.addEventListener('close', noter);

    // Un clic sur le fond ferme la fenêtre. Le <dialog> reçoit l'événement
    // lui-même lorsque le clic tombe hors de son contenu.
    fenetre.addEventListener('click', (e) => {
      if (e.target === fenetre) fermer();
    });

    // Retour d'inscription : le formulaire client de Shopify recharge la page
    // en ajoutant ?customer_posted=true. C'est le seul signal disponible ici,
    // l'objet Liquid `form` n'existant pas hors du bloc qui l'ouvre.
    const volet = (nom) => {
      fenetre.querySelectorAll('[data-volet]').forEach((v) => {
        v.hidden = v.dataset.volet !== nom;
      });
    };

    if (new URLSearchParams(location.search).get('customer_posted') === 'true') {
      volet('merci');
      noter();
      ouvrir();
      return;
    }

    const jours = (Date.now() - lu()) / 86400000;
    if (lu() && jours < repos) return;

    if (delai > 0) {
      window.setTimeout(ouvrir, delai * 1000);
    } else {
      ouvrir();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["produit-onglets-maison"] && !Shopify.designMode) return;
  try {
    
  /**
   * Transforme l'accordéon en onglets au-dessus de 750 px.
   * Amélioration progressive : sans ce script, l'accordéon natif reste
   * utilisable et tout le contenu demeure lisible.
   */
  class MaisonOnglets extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('.onglets__item')];
      if (this.items.length < 2) return;

      this.mq = window.matchMedia('(min-width: 750px)');
      this.actif = 0;

      this.barre = document.createElement('div');
      this.barre.className = 'onglets__barre';
      this.barre.setAttribute('role', 'tablist');

      this.items.forEach((item, i) => {
        const libelle = item.querySelector('.onglets__titre span')?.textContent?.trim() ?? '';
        const panneau = item.querySelector('.onglets__panneau');
        const id = `${this.dataset.uid || 'ong'}-${i}`;

        const onglet = document.createElement('button');
        onglet.type = 'button';
        onglet.className = 'onglets__onglet';
        onglet.textContent = libelle;
        onglet.id = `${id}-t`;
        onglet.setAttribute('role', 'tab');
        onglet.setAttribute('aria-controls', `${id}-p`);
        onglet.addEventListener('click', () => this.activer(i));
        onglet.addEventListener('keydown', (e) => this.clavier(e, i));
        this.barre.appendChild(onglet);

        if (panneau) {
          panneau.id = `${id}-p`;
          panneau.setAttribute('role', 'tabpanel');
          panneau.setAttribute('aria-labelledby', `${id}-t`);
        }
      });

      this.prepend(this.barre);
      this.appliquer();
      this.mq.addEventListener('change', () => this.appliquer());

      // Un clic sur un titre en mode accordéon met à jour l'onglet actif,
      // pour que le passage d'un mode à l'autre reste cohérent.
      this.items.forEach((item, i) => {
        item.addEventListener('toggle', () => {
          if (!this.classList.contains('onglets--tabs') && item.open) this.actif = i;
        });
      });
    }

    appliquer() {
      const onglets = this.mq.matches;
      this.classList.toggle('onglets--tabs', onglets);
      if (onglets) this.activer(this.actif);
      else this.items.forEach((item, i) => { item.open = i === this.actif; });
    }

    activer(i) {
      this.actif = i;
      this.items.forEach((item, j) => { item.open = j === i; });
      [...this.barre.children].forEach((b, j) => {
        const courant = j === i;
        b.classList.toggle('is-active', courant);
        b.setAttribute('aria-selected', courant ? 'true' : 'false');
        b.tabIndex = courant ? 0 : -1;
      });
    }

    clavier(e, i) {
      const n = this.items.length;
      let cible = null;
      if (e.key === 'ArrowRight') cible = (i + 1) % n;
      if (e.key === 'ArrowLeft') cible = (i - 1 + n) % n;
      if (e.key === 'Home') cible = 0;
      if (e.key === 'End') cible = n - 1;
      if (cible === null) return;
      e.preventDefault();
      this.activer(cible);
      this.barre.children[cible].focus();
    }
  }

  if (!customElements.get('maison-onglets')) {
    customElements.define('maison-onglets', MaisonOnglets);
  }

  } catch(e) { console.error(e); }
})();
})();
